<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_2"><span>Elf Shot</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Norm-NoInd">By TA Moore</p>
<p class="P_Normal"> </p>
<p class="P_Normal">All Conri wanted was to drop his kid off at Changeling camp, find the nearest halfway nice hotel, and enjoy a week of uncomplicated debauchery. It should be simple. It doesn’t work out that way.</p>
<p class="P_Normal">When a local girl disappears, the neighborhood quickly lays blame at the well-guarded gates of the camp. With his son incriminated, a mystery to solve, and a malevolent pocket of the Otherworld to navigate, Conri will need all the help he can get—even if it does come from a distractingly pretty, tightly wound Iron Door agent who doesn’t trust Conri to be on the right side.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0002.vue?fad8838e